<template>
  <tr>
    <td>
      <router-link :to="`/products/${product.id}`">
        {{ product.name }}
      </router-link>
    </td>
    <td v-text="product.product_category ? product.product_category.name : ''"></td>
    <td v-text="product.unit ? product.unit.name : ''"></td>
    <td class="text-right" v-if="hideableColumns.showEkPrice">
      {{ product.einkaufspreis | priceFromCentEuro }}
    </td>
    <td class="text-right">{{ product.price | priceFromCentEuro }}</td>
    <td class="text-right">
      {{ product.quantity_sum || null }}
    </td>
    <td class="text-right">
      {{ product.inventur_quantity }}
    </td>
    <td class="text-right">
      {{ product.ordered_quantity || null }}
    </td>
    <td class="text-right" v-if="hideableColumns.showWarnschwelle">
      {{ product.warnschwelle_config || null }}
    </td>
    <td class="text-right" v-if="hideableColumns.showSollMenge">
      {{ product.soll_menge_config || null }}
    </td>
    <td class="nowrap">{{ product.next_expiry_date | date }}</td>
    <td class="text-center" v-if="hideableColumns.showLager">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openWarehouses', product)">
        <i class="fas fa-warehouse"></i>
      </a>
    </td>
    <td class="text-center" v-if="hideableColumns.showLieferanten">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openSuppliers', {product, productSuppliersSorted})">
        <i class="fas fa-truck"></i>
      </a>
    </td>
  </tr>
</template>

<script>
import { groupNewestSuppliers } from 'src/util/helpers'

export default {
  props: ['product', 'onlyShowAction', 'hideableColumns'],
  computed: {
    productSuppliersSorted () {
      return groupNewestSuppliers(this.product.suppliers)
    }
  }
}
</script>

<style>
</style>
